import {React} from '@api'
import {Icon} from '@blueprintjs/core'
import {BoxIcon, LineIcon} from '~components/icons'

export const whiteboardIcons = {
  rect:  <BoxIcon/>,
  line: <LineIcon/>,
  ellipse: <Icon icon='circle'/>
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/icons.tsx